import LogoWithText from '@/assets/logo_text_240.svg'
import { Box, Center, Flex, Stack, Text } from '@/components/ui'
import { SYSTEM_VERSION } from '@/constants/systemVersion'

type Props = {
  children: React.ReactNode
  centered?: boolean
  showGradationArea?: boolean
  showVersion?: boolean
}

export const SimpleLogoPageContainer = ({
  children,
  centered = false,
  showGradationArea = false,
  showVersion = true,
}: Props) => {
  return (
    <Flex h="svh" w="svw">
      {showGradationArea && (
        <Box
          display={{ base: 'none', desktop: 'block' }}
          background="linear-gradient(140deg, var(--chakra-colors-blue-400, #6997F1) -6.11%, var(--chakra-colors-cyan-300, #76E4F7) 109.02%)"
          w="50svw"
        />
      )}
      <Stack
        pos="relative"
        direction="column"
        align="center"
        overflow="auto"
        flex="1"
        w="full"
        minW="72"
        justify={centered ? 'center' : 'start'}
        h={centered ? 'auto' : 'full'}
        pt={centered ? 'auto' : '40'}
        pb={centered ? undefined : showVersion ? '16' : '10'} // バージョン表示がある場合は下部にさらにスペースを確保
        my={centered ? 'auto' : '0'}
        px={{ base: '6', desktop: '8' }}
        gap="12"
      >
        <Box boxSize="max-content">
          <LogoWithText />
        </Box>
        <Center
          flexDirection="column"
          flex="1"
          w="full"
          maxW={showGradationArea ? '560px' : '800px'}
        >
          {children}
        </Center>
      </Stack>
      {showVersion && (
        <Center
          pos="absolute"
          bottom="0"
          right="0"
          w={showGradationArea ? { base: 'full', desktop: '50%' } : 'full'}
          px="2"
          py="3"
          bg="white"
        >
          <Text color="gray.500">ver.{SYSTEM_VERSION}</Text>
        </Center>
      )}
    </Flex>
  )
}
